import React from 'react';
import PropTypes from 'prop-types';

const MapFormCitiesSelector = ({ value }) => {
  return (
    <select
      id='city-selector'
      multiple
      value={value}
      readOnly
      className='form-control'
      >
      <option value='Portland, ME'>Portland, ME</option>
      <option value='Boston, MA'>Boston, MA</option>
      <option value='New York, NY'>New York, NY</option>
      <option value='Burlington, VT'>Burlington, VT</option>
      <option value='Buffalo, NY'>Buffalo, NY</option>
      <option value='Syracuse, NY'>Syracuse, NY</option>
      <option value='Albany, NY'>Albany, NY</option>
      <option value='Philadelphia, PA'>Philadelphia, PA</option>
      <option value='Washington DC-Baltimore'>Washington DC-Baltimore</option>
      <option value='Pittsburgh, PA'>Pittsburgh, PA</option>
      <option value='Richmond-Virginia Beach, VA'>Richmond-Virginia Beach, VA</option>
      <option value='Roanoke, VA'>Roanoke, VA</option>
      <option value='Charleston, WV'>Charleston, WV</option>
      <option value='Raleigh-Greensboro-Fayetteville, NC'>Raleigh-Greensboro-Fayetteville, NC</option>
      <option value='Wilmington, NC-Myrtle Beach, SC'>Wilmington, NC-Myrtle Beach, SC</option>
      <option value='Charlotte, NC'>Charlotte, NC</option>
      <option value='Greenville, SC'>Greenville, SC</option>
      <option value='Columia, SC'>Columia, SC</option>
      <option value='Charleston, SC'>Charleston, SC</option>
      <option value='Atlanta, GA'>Atlanta, GA</option>
      <option value='Savannah, GA'>Savannah, GA</option>
      <option value='Macon, GA'>Macon, GA</option>
      <option value='Jacksonville, FL'>Jacksonville, FL</option>
      <option value='Orlando-Tampa, FL'>Orlando-Tampa, FL</option>
      <option value='Miami, FL'>Miami, FL</option>
      <option value='Tallahassee, FL'>Tallahassee, FL</option>
      <option value='Mobile, AL'>Mobile, AL</option>
      <option value='Montgomery, AL'>Montgomery, AL</option>
      <option value='Birmingham, AL'>Birmingham, AL</option>
      <option value='Chattanooga, TN-Huntsville, AL'>Chattanooga, TN-Huntsville, AL</option>
      <option value='Tupelo, MS'>Tupelo, MS</option>
      <option value='New Orleans-Baton Rouge, LA'>New Orleans-Baton Rouge, LA</option>
      <option value='Jackson, MS'>Jackson, MS</option>
      <option value='Lake Charles-Lafayette, LA'>Lake Charles-Lafayette, LA</option>
      <option value='Shreveport, LA'>Shreveport, LA</option>
      <option value='Memphis, TN'>Memphis, TN</option>
      <option value='Nashville, TN'>Nashville, TN</option>
      <option value='Knoxville, TN'>Knoxville, TN</option>
      <option value='Lexington, KY'>Lexington, KY</option>
      <option value='Louisville, KY'>Louisville, KY</option>
      <option value='Paducah, KY'>Paducah, KY</option>
      <option value='Evansville, IN'>Evansville, IN</option>
      <option value='Cincinnati, OH'>Cincinnati, OH</option>
      <option value='Columbus, OH'>Columbus, OH</option>
      <option value='Cleveland, OH'>Cleveland, OH</option>
      <option value='Detroit, MI'>Detroit, MI</option>
      <option value='Grand Rapids-Kalamazoo-Lansing, MI'>Grand Rapids-Kalamazoo-Lansing, MI</option>
      <option value='Fort Wayne, IN'>Fort Wayne, IN</option>
      <option value='Indianapolis, IN'>Indianapolis, IN</option>
      <option value='Marquette, MI'>Marquette, MI</option>
      <option value='Sault Ste. Marie-Traverse City, MI'>Sault Ste. Marie-Traverse City, MI</option>
      <option value='Chicago, IL'>Chicago, IL</option>
      <option value='Milwaukee-Madison, WI'>Milwaukee-Madison, WI</option>
      <option value='Green Bay-Appleton, WI'>Green Bay-Appleton, WI</option>
      <option value='La Crosse-Eau Claire, WI'>La Crosse-Eau Claire, WI</option>
      <option value='Davenport, IA'>Davenport, IA</option>
      <option value='Springfield-Peoria-Bloomington, IL'>Springfield-Peoria-Bloomington, IL</option>
      <option value='St. Louis, MO'>St. Louis, MO</option>
      <option value='Springfield, MO'>Springfield, MO</option>
      <option value='Little Rock, AR'>Little Rock, AR</option>
      <option value='Fort Smith-Fayetteville, AR'>Fort Smith-Fayetteville, AR</option>
      <option value='Columbia, MO'>Columbia, MO</option>
      <option value='Kansas City, MO'>Kansas City, MO</option>
      <option value='Des Moines, IA'>Des Moines, IA</option>
      <option value='Minneapolis-St. Paul, MN'>Minneapolis-St. Paul, MN</option>
      <option value='Duluth, MN'>Duluth, MN</option>
      <option value='Fargo-Grand Forks, ND'>Fargo-Grand Forks, ND</option>
      <option value='Minot, ND'>Minot, ND</option>
      <option value='Bismark, ND'>Bismark, ND</option>
      <option value='Aberdeen, SD'>Aberdeen, SD</option>
      <option value='Sioux Falls, SD'>Sioux Falls, SD</option>
      <option value='Rapid City, SD'>Rapid City, SD</option>
      <option value='Omaha-Lincoln, NE'>Omaha-Lincoln, NE</option>
      <option value='Grand Island-North Platte, NE'>Grand Island-North Platte, NE</option>
      <option value='Topeka, KS'>Topeka, KS</option>
      <option value='Wichita, KS'>Wichita, KS</option>
      <option value='Dodge City-Goodland, KS'>Dodge City-Goodland, KS</option>
      <option value='Tulsa, OK'>Tulsa, OK</option>
      <option value='Oklahoma City, OK'>Oklahoma City, OK</option>
      <option value='Lawton, OK'>Lawton, OK</option>
      <option value='DFW'>DFW</option>
      <option value='Abilene, TX'>Abilene, TX</option>
      <option value='Austin, TX'>Austin, TX</option>
      <option value='San Antonio, TX'>San Antonio, TX</option>
      <option value='Houston, TX'>Houston, TX</option>
      <option value='Corpus Christi, TX'>Corpus Christi, TX</option>
      <option value='Brownsville-McAllen, TX'>Brownsville-McAllen, TX</option>
      <option value='Del Rio-Eagle Pass, TX'>Del Rio-Eagle Pass, TX</option>
      <option value='San Angelo, TX'>San Angelo, TX</option>
      <option value='Midland-Odessa, TX'>Midland-Odessa, TX</option>
      <option value='Lubbock, TX'>Lubbock, TX</option>
      <option value='Amarillo, TX'>Amarillo, TX</option>
      <option value='El Paso, TX'>El Paso, TX</option>
      <option value='Roswell-Alamogordo, NM'>Roswell-Alamogordo, NM</option>
      <option value='Albuquerque, NM'>Albuquerque, NM</option>
      <option value='Pueblo, CO'>Pueblo, CO</option>
      <option value='Denver, CO'>Denver, CO</option>
      <option value='Cheyenne, WY'>Cheyenne, WY</option>
      <option value='Casper-Riverton, WY'>Casper-Riverton, WY</option>
      <option value='Billings, MT'>Billings, MT</option>
      <option value='Great Falls, MT'>Great Falls, MT</option>
      <option value='Missoula, MT'>Missoula, MT</option>
      <option value='Salt Lake City, UT'>Salt Lake City, UT</option>
      <option value='Pocatello, ID'>Pocatello, ID</option>
      <option value='Boise, ID'>Boise, ID</option>
      <option value='Phoenix, AZ'>Phoenix, AZ</option>
      <option value='Tucson, AZ'>Tucson, AZ</option>
      <option value='Flagstaff, AZ'>Flagstaff, AZ</option>
      <option value='Las Vegas, NV'>Las Vegas, NV</option>
      <option value='St. George, UT'>St. George, UT</option>
      <option value='Yuma, AZ'>Yuma, AZ</option>
      <option value='Reno, NV'>Reno, NV</option>
      <option value='Los Angeles, CA'>Los Angeles, CA</option>
      <option value='Fresno, CA'>Fresno, CA</option>
      <option value='San Francisco-San Jose, CA'>San Francisco-San Jose, CA</option>
      <option value='Sacramento, CA'>Sacramento, CA</option>
      <option value='Medford, OR'>Medford, OR</option>
      <option value='Portland, OR'>Portland, OR</option>
      <option value='Seattle, WA'>Seattle, WA</option>
      <option value='Spokane, WA'>Spokane, WA</option>
    </select>
  )
}

export default MapFormCitiesSelector;



// WEBPACK FOOTER //
// ./src/browser/components/map-creator/map-form-cities-selector.js